export default __webpack_public_path__ + "static/media/office6small.a9f20f38.jpg";